export { AtnWidgetDialogComponent as Component } from './widget.component'
